"use client";

import { useLocale } from "next-intl";
import { toIntlLocale } from "@/platform/i18n/locale-utils";
import { formatPrice } from "./format-price";

interface PriceProps {
  value: number;
  currencyCode?: string;
}

export function Price({ value, currencyCode = "USD" }: PriceProps) {
  const locale = useLocale();

  return formatPrice(value, toIntlLocale(locale), currencyCode);
}
